export const MANAGER_LOG_SLICE = 'managerLog' as const;

// app/assets/stylesheets/_print.scss
export const NO_PRINT_CLASS = 'no-print' as const;
export const PRINT_ONLY_CLASS = 'print-only' as const;
